import { PageLayout } from "../layout";
import { LoginForm, TwoFaSetupForm, TwoFaVerifyForm } from "../../auth";
import React from "react";
import { observer } from "mobx-react";
import { useLoaderData, useNavigate } from "react-router";
import { useRootStore } from "../../store/contexts";
import { CssBaseline } from "@mui/material";
import { hostAudience, titleFor } from "../../audience/audience";

export const LoginPage = observer(() => {
  const { redirectUrl } = useLoaderData() as { redirectUrl: string };
  const rootStore = useRootStore();
  const auth = rootStore.authStore;
  const navigate = useNavigate();

  React.useEffect(() => {
    if (auth.status === "logged") {
      navigate(redirectUrl || "/", { replace: true });
    }
  }, [auth.status, navigate, redirectUrl]);

  if (auth.twoFaRequired && auth.twoFaAction === "setup") {
    return (
      <PageLayout>
        <TwoFaSetupForm />
      </PageLayout>
    );
  }

  if (auth.twoFaRequired && auth.twoFaAction === "verify") {
    return (
      <PageLayout>
        <TwoFaVerifyForm />
      </PageLayout>
    );
  }

  return (
    <>
      <CssBaseline />
      <LoginForm redirectUrl={redirectUrl} title={titleFor(hostAudience())} />
    </>
  );
});
